module.exports = __webpack_public_path__ + "static/media/arrow-left.1d14a968.svg";